import { useState, useRef, useEffect, useContext, useMemo } from "react";
//Components
import SingleDropDown from "./SingleDropDown";
import CheckboxWithLabel from "./CheckboxWithLabel";
import {
  FormControl,
  TextField,
  TextareaAutosize,
  FormLabel,
  Box,
  Modal,
  Button,
  IconButton,
  Tooltip,
} from "@material-ui/core";
//Context and actions
import { UserContext } from "../Contexts/UserContext";
import { IncidentsContext } from "../Contexts/IncidentsContext";
import { INCIDENT_ACTIONS } from "../Actions/IncidentActions";
import { MutationContext } from "../Contexts/MutationContext";
//utils
import { checkPermission } from "../utils/Roles";
import { useCookies } from "react-cookie";
import _ from "lodash";
//styling
import { useStyles } from "../Styles/styles";
import deleteButton from "../Assets/deleteButton.png";
import { ModalHeader } from "./ModalHeader";
import clsx from "clsx";
import { CgTemplate } from "react-icons/cg";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { localGetData } from "../utils/utils";
import { Autocomplete } from "@material-ui/lab";
import { getValueFromEventValue } from "../utils/getValueFromEventValue";

import moment from "moment";

const IncidentDetailNarrative = ({
  divStyle,
  formStyle,
  fabStyle,
  narrative,
  numOfNarratives,
  narrativeIndex,
  narrativeTypes,
  incidentId,
  incidentIndex,
  addNarrativeToIncident,
  canEditNarrative,
  userRoles,
  disabled = undefined,
  incidentOriId,
  ...props
}) => {
  const { user } = useContext(UserContext);
  const canViewConfidential = useMemo(() => {
    return (
      checkPermission(
        userRoles,
        "view_confidential_attachments",
        user?.secondarySiblingIds,
        incidentOriId,
        incidentId
      ) || narrative?.employee?.id === user?.id?.toString()
    );
  }, [
    incidentId,
    incidentOriId,
    narrative?.employee?.id,
    user?.id,
    user?.secondarySiblingIds,
    userRoles,
  ]);
  const memoizedLockedForNarrative = useMemo(() => {
    if (disabled !== null && disabled !== undefined) {
      return disabled;
    } else {
      if (
        !narrative?.employee?.id ||
        (narrative?.employee?.id &&
          user?.id?.toString() === narrative?.employee?.id?.toString())
      ) {
        //if there's no employee don't lock or if the employee is the user don't lock
        return false;
        //there is an employee and it's not the user, check their roles with canEditNarrative
      } else if (canEditNarrative) {
        //they can edit other officer's narratives so don't lock it
        return false;
      } else {
        //none of the above is true, lock it
        return true;
      }
    }
  }, [canEditNarrative, disabled, narrative?.employee, user?.id]);

  const classes = useStyles();
  const { incidentDispatch } = useContext(IncidentsContext);
  const { UPDATE_INCIDENT_DETAIL_NARRATIVE, REMOVE_INCIDENT_DETAIL_NARRATIVE } =
    INCIDENT_ACTIONS;
  const { addOrUpdateIncidentDetailNarrative, removeIncidentNarrative } =
    useContext(MutationContext);
  const officerBadge = narrative?.employee?.deptAttribute
    ? narrative.employee.deptAttribute.badge
    : "";
  const officerFirstName = narrative?.employee?.personalAttribute
    ? narrative.employee.personalAttribute.firstName
    : "";
  const officerLastName = narrative?.employee?.personalAttribute
    ? narrative.employee.personalAttribute.lastName
    : "";
  // const timestamp = moment(narrative?.timestamp).format("MM/DD/YY HH:mm") || ""
  const timestamp = narrative?.timestamp
    ? moment
        .utc(narrative?.timestamp, "YYYY-MM-DD HH:mm:ss UTC")
        .local()
        .format("MM/DD/YY HH:mm")
    : "";
  const [cookies] = useCookies();
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  const [collapseNarrative, setCollapseNarrative] = useState(true);
  const [narrativeTemplates, setNarrativeTemplates] = useState([]);

  useEffect(() => {
    let res = localGetData("narrative-templates-mp");
    const homeOriResult = res?.[user?.homeOriId] || [];
    const incidentOriResult = res?.[incidentOriId] || [];
    setNarrativeTemplates(
      _.uniqBy(homeOriResult.concat(incidentOriResult), "id")
    );
  }, [incidentOriId, user?.homeOriId]);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  const stateToMutation = {
    incidentNarrativeType: "incidentNarrativeTypeId",
    narrative: "narrative",
    confidential: "confidential",
  };

  const handleChange = (event, submit = true) => {
    const serverTimeFormat = moment.utc().format("YYYY-MM-DD HH:mm:ss UTC");
    if (event.target.type === "checkbox") {
      const bool = event.target.checked;
      const name = event.target.value;
      const fieldToUpdate = stateToMutation[name];

      incidentDispatch({
        type: UPDATE_INCIDENT_DETAIL_NARRATIVE,
        payload: {
          incidentIndex: incidentIndex,
          narrativeIndex: narrativeIndex,
          property: name,
          value: bool,
        },
      });
      addOrUpdateIncidentDetailNarrative({
        variables: {
          input: {
            incidentId: incidentId,
            incidentNarrativeId: narrative.id,
            [fieldToUpdate]: bool,
            originatorId: user?.id,
            officerId: user?.id,
          },
        },
      });
      !narrative?.timestamp &&
        incidentDispatch({
          type: UPDATE_INCIDENT_DETAIL_NARRATIVE,
          payload: {
            incidentIndex: incidentIndex,
            narrativeIndex: narrativeIndex,
            property: "timestamp",
            value: serverTimeFormat,
          },
        });
    } else {
      const name = event.target.name || null;
      const value = event.target.value;
      const mutationValue = getValueFromEventValue(value);
      const fieldToUpdate = stateToMutation[name];
      incidentDispatch({
        type: UPDATE_INCIDENT_DETAIL_NARRATIVE,
        payload: {
          incidentIndex: incidentIndex,
          narrativeIndex: narrativeIndex,
          property: name,
          value: value,
        },
      });
      submit &&
        addOrUpdateIncidentDetailNarrative({
          variables: {
            input: {
              incidentId: incidentId,
              incidentNarrativeId: narrative.id,
              [fieldToUpdate]: mutationValue,
              originatorId: user?.id,
              officerId: user?.id,
            },
          },
        });
      submit &&
        !narrative?.timestamp &&
        incidentDispatch({
          type: UPDATE_INCIDENT_DETAIL_NARRATIVE,
          payload: {
            incidentIndex: incidentIndex,
            narrativeIndex: narrativeIndex,
            property: "timestamp",
            value: serverTimeFormat,
          },
        });
      submit &&
        !narrative?.employee &&
        incidentDispatch({
          type: UPDATE_INCIDENT_DETAIL_NARRATIVE,
          payload: {
            incidentIndex: incidentIndex,
            narrativeIndex: narrativeIndex,
            property: "employee",
            value: user?.officer,
          },
        });
      if (!name) {
        alert(
          `Please add a name field that matches the state name to the component that was just updated`
        );
        return null;
      }
    }
  };

  const setOfficer = () => {
    const serverTimeFormat = moment.utc().format("YYYY-MM-DD HH:mm:ss UTC");
    if (!narrative?.timestamp || !narrative?.employee) {
      addOrUpdateIncidentDetailNarrative({
        variables: {
          input: {
            incidentId: incidentId,
            incidentNarrativeId: narrative.id,
            originatorId: user?.id,
            officerId: user?.id,
          },
        },
      });
      incidentDispatch({
        type: UPDATE_INCIDENT_DETAIL_NARRATIVE,
        payload: {
          incidentIndex: incidentIndex,
          narrativeIndex: narrativeIndex,
          property: "timestamp",
          value: serverTimeFormat,
        },
      });
      incidentDispatch({
        type: UPDATE_INCIDENT_DETAIL_NARRATIVE,
        payload: {
          incidentIndex: incidentIndex,
          narrativeIndex: narrativeIndex,
          property: "employee",
          value: user?.officer,
        },
      });
    }
  };

  const handleRemoveNarrative = () => {
    //Add mutation
    if (window.confirm("Are you sure you want to delete this narrative?")) {
      incidentDispatch({
        type: REMOVE_INCIDENT_DETAIL_NARRATIVE,
        payload: {
          incidentIndex: incidentIndex,
          narrativeIndex: narrativeIndex,
        },
      });
      removeIncidentNarrative({
        variables: {
          input: { originatorId: user?.id, incidentNarrativeId: narrative.id },
        },
      });
      if (numOfNarratives <= 1) {
        addNarrativeToIncident();
      }
    } else {
      return null;
    }
  };

  const [localNarrative, setLocalNarrative] = useState(
    narrative?.narrative || ""
  );

  // const [selectedTemplate, setSelectedTemplate] = useState(()=>narrativeTemplates?.sort((a,b) => +a.position - +b.position)[0])
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showTemplateModal, setShowTemplateModal] = useState(false);

  // const handleNarrativeSelection = (template) => {
  //   setSelectedTemplate(template)
  //   if (!localNarrative) {
  //     addNarrativeTemplate("replace", template?.content)
  //   } else {
  //     setShowTemplateModal(true)
  //   }
  // }

  const addNarrativeTemplate = mode => {
    if (!selectedTemplate) {
      window.alert("No template selected");
      return null;
    }
    let content = selectedTemplate?.content;
    if (mode === "append") content = localNarrative + "\n" + content;
    if (mode === "prepend") content = content + "\n" + localNarrative;
    if (mode === "replace" && localNarrative) {
      if (
        !window.confirm(
          "Are you sure you want to overwrite your current narrative with this template?"
        )
      ) {
        return null;
      }
    }

    handleChange(
      { target: { type: "synthetic", name: "narrative", value: content } },
      true
    );
    // incidentDispatch({ type: UPDATE_INCIDENT_DETAIL_NARRATIVE, payload: { incidentIndex: incidentIndex, narrativeIndex: narrativeIndex, property: "narrative", value: content } })
    // addOrUpdateIncidentDetailNarrative({ variables: { input: { incidentId: incidentId, incidentNarrativeId: narrative.id, narrative: content, originatorId: user?.id } } })
    // incidentDispatch({ type: UPDATE_INCIDENT_DETAIL_NARRATIVE, payload: { incidentIndex: incidentIndex, narrativeIndex: narrativeIndex, property: 'timestamp', value: serverTimeFormat } })
    // incidentDispatch({ type: UPDATE_INCIDENT_DETAIL_NARRATIVE, payload: { incidentIndex: incidentIndex, narrativeIndex: narrativeIndex, property: 'employee', value: user?.officer } })

    setLocalNarrative(content);
    setShowTemplateModal(false);
  };

  if (narrative.blocked) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        border: "1px solid lightgrey",
        marginBottom: "1vw",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        margin="auto 0"
        alignItems="center"
      >
        <SingleDropDown
          handleChange={handleChange}
          stateName={"incidentNarrativeType"}
          value={narrative?.incidentNarrativeType}
          options={narrativeTypes}
          title={"Narrative Type"}
          classStyle={formStyle}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          disabled={memoizedLockedForNarrative}
          userRoles={userRoles}
          {...props}
        />

        <Tooltip title="Narrative Templates">
          <IconButton
            disabled={memoizedLockedForNarrative}
            onClick={() => setShowTemplateModal(true)}
          >
            <CgTemplate
              style={{ fontSize: "3vw", alignItems: "center" }}
            ></CgTemplate>
          </IconButton>
        </Tooltip>
      </Box>
      <Box display="flex" flexDirection="column" flexGrow="2" margin="auto 0">
        <Box display="flex" flexDirection="row" alignItems="center">
          <FormLabel data-cy={"new-narrative-label"} component="label">
            {"Narrative"}
          </FormLabel>
          <IconButton
            edge="start"
            onClick={() => setCollapseNarrative(prevState => !prevState)}
            style={{ margin: 0 }}
          >
            {collapseNarrative ? <ExpandMore /> : <ExpandLess />}
          </IconButton>
        </Box>
        <TextareaAutosize
          // disabled={narrative?.employee?.id && narrative?.employee?.id.toString() !== user?.id.toString() ? true : false}
          disabled={memoizedLockedForNarrative}
          data-cy="newNarrative"
          className={
            cookies[`mp-userId-${user?.id}-night-mode`] === "true"
              ? classes.textAreaDark
              : classes.textAreaLight
          }
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: "1rem",
          }}
          margin="dense"
          id="narrative-id"
          value={
            narrative?.confidential && !canViewConfidential
              ? ""
              : localNarrative
          }
          onChange={e => {
            setOfficer();
            setLocalNarrative(e.target.value);
          }}
          onBlur={e => {
            setLocalNarrative(e.target.value);
            handleChange(e, true);
          }}
          minRows={3}
          maxRows={collapseNarrative ? 3 : null}
          name="narrative"
        />
      </Box>
      <Box display="flex" flexDirection="row" flexWrap="wrap">
        <FormControl variant="standard" className={formStyle}>
          <TextField
            disabled
            data-cy="officer"
            inputProps={{ "data-cy": "officer-input" }}
            InputLabelProps={{ "data-cy": "officer-input-label" }}
            margin="dense"
            id={"officer-id-" + narrative.id}
            label="Officer"
            value={`${officerBadge ? officerBadge + ": " : ""}${
              officerLastName ? officerLastName + ", " : ""
            }${
              officerFirstName ? officerFirstName.charAt(0) + ": " : ""
            }${timestamp}`}
            name="officer"
            style={{ width: "15vw" }}
          />
        </FormControl>
        <FormControl variant="standard" className={formStyle}>
          <CheckboxWithLabel
            formStyle={formStyle}
            checked={narrative?.confidential || false}
            onChange={handleChange}
            stateName={"confidential"}
            title={"Confidential"}
            disabled={memoizedLockedForNarrative}
            userRoles={userRoles}
            {...props}
          />
        </FormControl>
        <FormControl
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          className={formStyle}
        >
          {/* <img data-cy={"delete-narrative-button-" + narrative?.id} src={deleteButton} onClick={!canEditNarrative ? () => handleRemoveNarrative() : null} className={classes.pngButton} alt="Delete Narrative" /> */}
          {!memoizedLockedForNarrative && (
            <button
              type="button"
              onClick={handleRemoveNarrative}
              style={{ background: "none", border: 0, padding: 0 }}
            >
              <img
                data-cy={"delete-narrative-button-" + narrative?.id}
                src={deleteButton}
                className={classes.pngButton}
                alt="Delete Narrative"
              />
            </button>
          )}

          {/* <Fab className={fabStyle} onClick={handleRemoveNarrative}><RemoveCircleOutlineIcon /></Fab> */}
        </FormControl>
      </Box>
      <Modal
        keepMounted={false}
        open={showTemplateModal}
        onClose={() => setShowTemplateModal(false)}
        className={classes.modal}
        style={{ width: "fit-content", margin: "auto" }}
        data-cy="narrative-template-modal"
        onKeyDown={e => e.key === "Escape" && setShowTemplateModal(false)}
        disablePortal={true}
      >
        <div
          id={"tabs-wrapper"}
          style={{
            height: "fit-content",
            width: "fit-content",
            borderRadius: "5px",
          }}
          className={classes.tabRoot}
        >
          <ModalHeader
            headerName={"Narrative Templates"}
            setModalOpen={setShowTemplateModal}
            nightMode={cookies[`mp-userId-${user?.id}-night-mode`] === "true"}
            helpIconObjectName={""}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Autocomplete
              id="grouped-narrative-templates"
              openOnFocus={true}
              options={narrativeTemplates?.sort((a, b) => {
                if (a.templateType === "System" && b.templateType !== "System")
                  return 1;
                if (a.templateType !== "System" && b.templateType === "System")
                  return -1;
                if (a.ori.abbreviation > b.ori.abbreviation) return 1;
                if (a.ori.abbreviation < b.ori.abbreviation) return -1;
                return 0;
              })}
              groupBy={option => {
                if (option.templateType === "System") {
                  return "System";
                } else {
                  return option?.ori?.abbreviation;
                }
              }}
              value={selectedTemplate}
              onChange={(event, newValue) => {
                setSelectedTemplate(newValue);
              }}
              getOptionLabel={option => option.name}
              style={{ width: "100%" }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Narrative Template"
                  variant="outlined"
                />
              )}
            />
            {/* <SingleDropDown
              handleChange={(e) => setSelectedTemplate(e.target.value)}
              stateName={'narrativeTemplate'}
              value={selectedTemplate}
              options={narrativeTemplates}
              title={'Narrative Template'}
              classStyle={formStyle}
              inputLabel={inputLabel}
              labelWidth={labelWidth}
              disabled={memoizedLockedForNarrative}
              userRoles={userRoles}
              {...props}
            /> */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              {/* <button style={{margin: '10px'}}onClick={() => addNarrativeTemplate("prepend")}>Prepend</button>
              <button style={{margin: '10px'}}onClick={() => addNarrativeTemplate("append")}>Append</button>
              <button style={{margin: '10px'}}onClick={() => addNarrativeTemplate("replace")}>Replace</button>
              <button style={{margin: '10px'}}onClick={() => setShowTemplateModal(false)}>Cancel</button> */}
              {localNarrative && (
                <Button
                  onClick={() => addNarrativeTemplate("prepend")}
                  className={clsx(classes.buttonHover, classes.navBarButtons)}
                  variant="contained"
                  style={{ margin: "1em" }}
                >
                  Prepend
                </Button>
              )}
              {localNarrative && (
                <Button
                  onClick={() => addNarrativeTemplate("append")}
                  className={clsx(classes.buttonHover, classes.navBarButtons)}
                  variant="contained"
                  style={{ margin: "1em" }}
                >
                  Append
                </Button>
              )}
              <Button
                onClick={() => addNarrativeTemplate("replace")}
                className={clsx(classes.buttonHover, classes.navBarButtons)}
                variant="contained"
                style={{ margin: "1em" }}
              >
                {localNarrative ? "Replace" : "Submit"}
              </Button>
              <Button
                onClick={() => setShowTemplateModal(false)}
                className={clsx(classes.buttonHover, classes.navBarButtons)}
                variant="contained"
                style={{ margin: "1em" }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default IncidentDetailNarrative;
